var _ = require('underscore');
var Section = require('front/pages/Section/Section');

require('./Members.less');

var MembersList = require('front/components/MembersList/MembersList');
var CommonSearchInput = require('front/components/CommonSearchInput/CommonSearchInput');


module.exports = Section.extend({

    el: '.Members',

    events: {
        'click .Members-filter-item > span': 'openItemMenu',
        'change .Members-filter-item--portfolio input': 'openItemMenu',
        'click .Members-filter-itemMenu-close': 'closeItemMenu',
        'click .Members-filter-itemMenu-applyBtn': 'closeItemMenu',
        'submit .Members-form': 'onSubmit',
        'click .Members-filterClear': 'clearFilter',
        'click .MembersListInner-empty span': 'clearFilter',

        'click .Members-filter-item.Members-filter-item--job .Members-filter-itemMenu-categoryItem': 'onItemClick',
        'click .Members-filter-item.Members-filter-item--job .Members-filter-itemMenu-categoryName': 'onItemClick',
        'click .Members-filter-item.Members-filter-item--location .Members-filter-itemMenu-categoryItem': 'onItemClick',
        'click .Members-filter-item.Members-filter-item--domicile .Members-filter-itemMenu-categoryItem': 'onItemClick',

        'touchstart .Members-filter-itemMenu': 'onTouchStart',
        'touchmove .Members-filter-itemMenu': 'onTouchMove'
    },


    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'CommonSearchInput': {selector: '.CommonSearchInput', viewConstructor: CommonSearchInput}
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'onResize', 'getFilterItems', 'changeItemsFilter', 'getUrlVars');

        this.filterItem = {};

        this.$MembersListInner = $('.MembersListInner');

        if (!app.settings.isPhone) {
            $('.Members-filter-item--job .Members-filter-itemMenu-inner').masonry({
                itemSelector: '.Members-filter-itemMenu-category',
                columnWidth: '.Members-filter-itemMenu-category'
            });

            $('.Members-filter-item--domicile .Members-filter-itemMenu-inner').masonry({
                itemSelector: '.Members-filter-itemMenu-category',
                columnWidth: '.Members-filter-itemMenu-category'
            });


            this.jobJsp = $('.Members-filter-item--job .Members-filter-itemMenu-scrollBlock')
                .jScrollPane()
                .bind('mousewheel', function (e) {
                    e.preventDefault();
                })
                .data('jsp');

            this.skillsJsp = $('.Members-filter-item--skills .Members-filter-itemMenu-scrollBlock')
                .jScrollPane()
                .bind('mousewheel', function (e) {
                    e.preventDefault();
                })
                .data('jsp');

            this.locationJsp = $('.Members-filter-item--location .Members-filter-itemMenu-scrollBlock')
                .jScrollPane()
                .bind('mousewheel', function (e) {
                    e.preventDefault();
                })
                .data('jsp');

            this.domicileJsp = $('.Members-filter-item--domicile .Members-filter-itemMenu-scrollBlock')
                .jScrollPane()
                .bind('mousewheel', function (e) {
                    e.preventDefault();
                })
                .data('jsp');
        }

        $(window).on('resize', this.onResize);
        this.onResize();

        var urlParams = this.getUrlVars();
        var skills = urlParams.skills ? urlParams.skills.split(',') : [];

        var fields = ['query', 'job', 'domicile', 'skills', 'location', 'hasPortfolio'];

        this.filterItem = _.chain(fields).map(function (field) {
            if (!urlParams[field]) {
                return undefined;
            }
            var value = urlParams[field].split(',');

            return [field, value.length > 1 ? value : value[0]];
        })
            .compact()
            .object()
            .value();

        new MembersList({
            el: this.$('.MembersList'),
            filter: this.filterItem
        });

        this.changeItemsFilter(true);

        window.app.vent.on('MembersListInner-clearFilter', this.clearFilter);

        Section.prototype.initialize.call(this, options);
    },


    onTouchStart: function (e) {
        this.popupScrollY = e.originalEvent.touches.item(0).clientY;
    },


    onTouchMove: function (e) {
        if (!app.settings.isPhone) return;

        var $scrollbox = $(e.currentTarget).find('.Members-filter-itemMenu-scrollBlock');

        var $target = $(e.target);
        var delta = this.popupScrollY - e.originalEvent.touches.item(0).clientY;

        if (!$target.closest($scrollbox).length) {
            e.preventDefault();
        }

        if ((delta < 0 && $scrollbox.scrollTop() <= 0) ||
            (delta > 0 && $scrollbox.scrollTop() + $scrollbox.outerHeight() >= $scrollbox[0].scrollHeight - 1)) { //-1 due to scaling float sizes
            e.preventDefault();
        }

        this.popupScrollY = e.originalEvent.touches.item(0).clientY;
    },


    onResize: function () {
        if (!app.settings.isPhone) {
            this.jobJsp.reinitialise();
            this.skillsJsp.reinitialise();
            this.locationJsp.reinitialise();
            this.domicileJsp.reinitialise();
        }
    },

    openItemMenu: function (e) {
        var $item = $(e.currentTarget).parent();

        clearTimeout(this.dropdownTimeout);

        if (!$item.hasClass('Members-filter-item--portfolio')) {
            if ($item.hasClass('active')) {
                $item.removeClass('active');

                this.getFilterItems();
            } else {
                $('.Members-filter-item.active').removeClass('active');

                $item.addClass('active');

                var $dropdown = $item.find('.Members-filter-itemMenu');

                this.dropdownTimeout = setTimeout(function () {
                    var bottom = $dropdown.offset().top + $dropdown.height() - $(window).scrollTop();
                    var wh = $(window).height();
                    var shift = bottom - wh;

                    if (shift > 0) {
                        app.animateWindowScroll($(window).scrollTop() + shift + 20);
                    }

                }.bind(this), 400);
            }
        } else {
            // $('.Members-filter-item.active').removeClass('active');
            this.getFilterItems();
        }
    },

    closeItemMenu: function () {
        clearTimeout(this.dropdownTimeout);

        $('.Members-filter-item.active').removeClass('active');

        this.getFilterItems();
    },


    onItemClick: function () {
        setTimeout(this.closeItemMenu.bind(this), 17);
    },


    activate: function () {
        return Section.prototype.activate.call(this);
    },


    viewsRegistration: function () {
        Section.prototype.viewsRegistration.call(this);

        this.searchInput = this.getView('CommonSearchInput');

        this.searchInput.on('blur', this.getFilterItems);
        this.searchInput.on('enter-pressed', this.getFilterItems);
    },


    deactivate: function (params) {

        this.searchInput.off('blur', this.getFilterItems);
        this.searchInput.off('enter-pressed', this.getFilterItems);

        return Section.prototype.deactivate.call(this, params);
    },


    render: function () {
        var result = Section.prototype.render.call(this);

        return result;
    },


    onSubmit: function (e) {
        e.preventDefault();
        e.stopPropagation();
    },


    getFilterItems: function () {

        var changed = {};

        var oldFilter = _.extend({}, this.filterItem || {});

        this.filterItem = {};

        var fields = ['query', 'job', 'domicile', 'skills', 'location', 'hasPortfolio'];

        // if (!this.$MembersListInner.hasClass('MembersListInner--searched')) {
        //     this.$MembersListInner.removeClass('MembersListInner--featured');
        //     this.$MembersListInner.addClass('MembersListInner--searched');

        //     $('.Members-filterClear').addClass('active');
        // }

        var formData = $('.Members-form').serializeObject();
        _.each(fields, function (field) {
            var value = formData[field];
            if (value || oldFilter[field]) {
                if (value) {
                    this.filterItem[field] = value;
                };
                var difference = value && value.push && _.difference(value, oldFilter[field]) || undefined;
                if (difference && !difference.length) {
                    return;
                }
                difference = value !== oldFilter[field] ? value : null;
                if (difference !== null) {
                    changed[field] = difference;
                }
            }
        }.bind(this));

        var changedFields = _.keys(changed);

        //check if search filter is empty or only portfolio is selected
        var filterParamsCount = _.keys(this.filterItem).length;
        var isFilterEmpty = filterParamsCount == 0 || (filterParamsCount == 1 && this.filterItem.hasPortfolio != undefined);

        this.$MembersListInner.toggleClass('MembersListInner--searched', !isFilterEmpty);
        this.$MembersListInner.toggleClass('MembersListInner--featured', isFilterEmpty);

        // $('.Members-filterClear').toggleClass('active', searched);

        if (changedFields.length) {
            this.changeItemsFilter(false);
            window.app.vent.trigger('Members-filtred', this.filterItem);
        }
    },

    clearFilter: function () {
        this.$('.CommonSearchInput input').val('');

        $('.Members-filter-input').removeAttr('checked');

        this.closeItemMenu();
        // $('.Members-filterClear').removeClass('active');
    },

    changeItemsFilter: function (isFirstLoad) {
        var fields = ['job', 'domicile', 'skills', 'location'];

        if (this.filterItem.query) {
            if (isFirstLoad) {
                this.$('.CommonSearchInput input').val(this.filterItem.query);
            }
        }

        _.each(fields, function (field) {

            var $label = $('.Members-filter-item--' + field + ' > span');

            var value = _.chain((
                _.isArray(this.filterItem[field])
                    ? this.filterItem[field]
                    : [this.filterItem[field]]))
                .map(function (value) {
                    var $el = $('.Members-filter-item--' + field + ' input[value="' + value + '"]');
                    $el.attr('checked', 'checked');

                    return $el.next().text();
                }.bind(this))
                .compact()
                .value()
                .join(', ');

            $label.html(value || $label.data('default'));

        }.bind(this));

        if (this.filterItem.hasPortfolio) {
            if (isFirstLoad) {
                $('.Members-filter-item--portfolio input').attr('checked','checked');
            }
        }

        //check if search filter is empty or only portfolio is selected
        var filterParamsCount = _.keys(this.filterItem).length;
        var isFilterEmpty = filterParamsCount == 0 || (filterParamsCount == 1 && this.filterItem.hasPortfolio != undefined);

        $('.Members-filter-item--portfolio').toggleClass('enabled', !isFilterEmpty);
        $('.Members-filterClear').toggleClass('enabled', !isFilterEmpty);
    },

    getUrlVars: function () {
        var vars = [];
        var hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

        for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            hash[1] = decodeURIComponent(hash[1]);
            vars[hash[0]] = hash[1];
        }

        return vars;
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Members/Members.js
// module id = 284
// module chunks = 0